import type { Access } from '~/modules/access';
import { routes } from '~/app/routes';

export interface Guard {
  /** What a refused person was trying to open, for the NoPermission block. */
  resource: string;
  allow: (access: Access) => boolean;
}

const globalAdminOnly = (access: Access) => access.isGlobalAdmin;

// D-17. UI hiding is not authorization; the service enforces the same rules (Phase 5 Track G).
export const GUARDS = {
  featureFlags: { resource: 'Feature flags', allow: (access) => access.canUseFeatureFlags },
  ai: { resource: 'AI Manager', allow: (access) => access.canUseAiManager },
  mlsAgreements: { resource: 'MLS agreements', allow: (access) => access.canUseMlsAgreements },
  notifications: { resource: 'Notifications', allow: (access) => access.canUseNotifications },
  customerOnboard: { resource: 'Customer onboarding', allow: globalAdminOnly },
} satisfies Record<string, Guard>;

/** Gates on a page that has no route of its own to guard: the Onboard button. */
export const canOnboardCustomers = GUARDS.customerOnboard.allow;

/** A path that a `RequireAccess` wraps, for tests and the nav. Utilities is deliberately absent (open to signed-in users). */
export const GUARDED_ROUTES: { path: string; guard: Guard }[] = [
  { path: routes.featureFlags, guard: GUARDS.featureFlags },
  { path: routes.ai, guard: GUARDS.ai },
  { path: routes.mlsAgreements, guard: GUARDS.mlsAgreements },
  { path: routes.notifications, guard: GUARDS.notifications },
  { path: routes.customerNew, guard: GUARDS.customerOnboard },
];
